import { type EmployeeInfo } from '../../types/site.types';

const EMPLOYEE_KEY = 'employee';

/**
 * Checks to see if employee is authenticated and siteViewPreference is 'Internal'
 */
export function showAsEmployee(employee: EmployeeInfo): boolean {
	return employee.isAuthenticated && employee.siteViewPreference === 'Internal';
}

/**
 * Stores in localStorage if the employee is authenticated
 */
export const setRememberEmployee = (employee: EmployeeInfo): void => {
	if (employee.isAuthenticated) {
		localStorage.setItem(EMPLOYEE_KEY, 'true');
	}
};

/**
 * Returns true if the employee has authenticated in the past
 * Note: This does not check if the employee is currently authenticated
 */
export const hasEmployeeAuthenticated = (): boolean => {
	return Boolean(localStorage.getItem(EMPLOYEE_KEY));
};

/**
 * Replaces the substring 'Build with Ferguson' Build.com' with 'Ferguson Home'.
 */
export const replaceSiteName = (input: string): string => {
	return input.replace(/Build with Ferguson|Build\.com/gi, 'Ferguson Home');
};
